module.exports = __webpack_public_path__ + "static/media/la-cover-video.b3e0dcb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/LA/la-cover-video.jpg
// module id = 568
// module chunks = 0